/*
 * @Author: Hyman Choi
 * @Date: 2021-01-05 09:46:00
 * @LastEditTime: 2021-01-05 17:20:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.LiveWeb\src\api\notificationManagement.js
 */
import request from '@/utils/request'
import config from '@/utils/config';

/**
 * 获取预约观众
 *
 * @param {*} params
 */
export function sendNotification(data) {
  return request({
    url: config.API_LIVE + '/live_server/manage/live/sendNotification',
    method: 'post',
    headers: { 'content-type': 'application/json' },
    data
  })
}

/**
 * 获取预约观众
 *
 * @param {*} params
 */
export function getLiveAppointUser(params = {}) {
  return request({
    url: config.API_LIVE + '/live_server/manage/live/list/liveAppointUser',
    method: 'get',
    params
  })
}

/**
 * 获取关注观众
 *
 * @param {*} params
 */
export function getMyFollowingList(params = {}) {
  return request({
    url: config.API_MEDICAL + '/Api/V1/UserFollowers/MyFollowingList?',
    method: 'get',
    params
  })
}

/**
 * 获取搜索用户
 *
 * @param {*} params
 */
export function getUserList(params = {}) {
  return request({
    url: config.API_MEDICAL + '/Api/V1/Users/UserList',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/notificationManagement.js